import DefinitionEditor from '../definition/DefinitionEditor';

/**
 * Details-only region editor. Reuses DefinitionEditor for schema-driven fields
 * so Case Builder and future admin BlockSetup stay consistent.
 *
 * layout="embedded": no overlay — use inside BlockEditorSheet subview.
 * hideFooter: parent owns sticky Cancel/Save via actionsRef.
 */
export default function RegionDetailsForm({
    region,
    open,
    onSave,
    onCancel,
    layout = 'modal',
    hideChrome = false,
    hideFooter = false,
    saveLabel = null,
    cancelLabel = null,
    subtitle = null,
    readOnly = false,
    definitionContext = true,
    onDirtyChange = null,
    actionsRef = null,
}) {
    if (!open || !region) return null;

    return (
        <DefinitionEditor
            type="region"
            definition={region}
            onSave={onSave}
            onCancel={onCancel}
            isOpen={true}
            detailsOnly={true}
            definitionContext={definitionContext}
            layout={layout}
            hideChrome={hideChrome}
            hideFooter={hideFooter}
            saveLabel={saveLabel}
            cancelLabel={cancelLabel}
            subtitle={subtitle}
            readOnly={readOnly}
            onDirtyChange={onDirtyChange}
            actionsRef={actionsRef}
        />
    );
}
